
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop({ type: String }) public title!: string;
  @Prop({ type: Boolean, default: false }) public hasStart!: boolean;
  @Prop({ type: String, default: 'line-height:40px;font-size: 14px' }) public contactNumberStyle!: string;
}
